export const CACHE_CONTROL_7_DAYS_CDN_CACHE =
  'public, max-age=0, s-maxage=604800, stale-if-error=0, must-revalidate'

export const CACHE_CONTROL_NO_CACHE =
  'private, no-cache, no-store, stale-if-error=0, must-revalidate, max-age=0'
